// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"6ba98c0a","110":"69d0da56","471":"b861d327","934":"6fe9d3e3"}[chunkId] + ".chunk.js";
};